import { loader } from 'graphql.macro'

export default async function wastePayGetCustomerCards ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./wastepayGetCustomerCards.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, { clientId: variables.clientId })
}
